(function() {
  'use strict';

  const City = window.UKHCityDelivery;
  if (!City) return;

  const CONFIG = City.config;
  const Utils = City.utils;
  const PopupManager = City.popup;

const ProductManager = {
    setupAddToCartTrigger: function() {
      if (this.addToCartGuardReady) return;
      this.addToCartGuardReady = true;

      document.addEventListener('submit', (e) => {
        const form = e.target?.closest?.('form[action*="/cart/add"]');
        if (!form) return;

        const city = Utils.getSelectedCity();

        if (!city && CONFIG.showPopupOnAddToCart) {
          e.preventDefault();
          e.stopImmediatePropagation();

          PopupManager.show(true, () => {
            this.checkAndAddToCart(form);
          });
          return;
        }

        const productTags = this.getProductTags(form);
        if (!productTags) return;

        const isQuettaOnly = Utils.hasTag(productTags, CONFIG.restrictedTag);
        const isRestricted = isQuettaOnly && city !== 'Quetta';

        if (isRestricted) {
          e.preventDefault();
          e.stopImmediatePropagation();
          alert('This product can only be delivered to Quetta. Please change your location or choose a different product.');
        }
      }, true);
    },

    checkAndAddToCart: function(form = null) {
      const selectedCity = Utils.getSelectedCity();
      const targetForm = form || document.querySelector('form[action*="/cart/add"]');
      const productTags = this.getProductTags(targetForm);
      
      if (productTags) {
        const isQuettaOnly = Utils.hasTag(productTags, CONFIG.restrictedTag);
        const isRestricted = isQuettaOnly && selectedCity !== 'Quetta';
        
        if (isRestricted) {
          alert('This product is only available for delivery in Quetta. You selected ' + selectedCity + '.');
          return;
        }
      }

      if (targetForm) {
        const submitBtn = targetForm.querySelector('button[name="add"], .product-form__submit, .add-to-cart-button');
        if (submitBtn) {
          submitBtn.click();
        }
      }
    },

    checkRestrictions: function() {
      const selectedCity = Utils.getSelectedCity();
      if (!selectedCity) return;

      const productTags = this.getProductTags();
      if (!productTags) return;

      const isQuettaOnly = Utils.hasTag(productTags, CONFIG.restrictedTag);
      const isRestricted = isQuettaOnly && selectedCity !== 'Quetta';

      this.updateProductPage(isRestricted, isQuettaOnly, selectedCity);
    },

    getProductTags: function(form = null) {
      const scope = form?.closest?.('product-info, .main-product-redesign');
      const metaTag = scope?.querySelector?.('meta[property="product:tag"]')
        || document.querySelector('meta[property="product:tag"]');
      if (metaTag) {
        return metaTag.getAttribute('content');
      }

      if (typeof window.ShopifyAnalytics !== 'undefined' && 
          window.ShopifyAnalytics.meta && 
          window.ShopifyAnalytics.meta.product) {
        return window.ShopifyAnalytics.meta.product.tags;
      }

      const productJson = document.querySelector('[data-product-json]');
      if (productJson) {
        try {
          const product = JSON.parse(productJson.textContent);
          return product.tags;
        } catch(e) {
          console.error('Error parsing product JSON:', e);
        }
      }

      return null;
    },

    updateProductPage: function(isRestricted, isQuettaOnly, selectedCity) {
      const addToCartButtons = document.querySelectorAll(
        'button[name="add"], button[type="submit"][name="add"], .product-form__submit, [data-add-to-cart]'
      );

      const productForm = document.querySelector('form[action*="/cart/add"]');

      if (isRestricted) {
        addToCartButtons.forEach(btn => {
          btn.disabled = true;
          btn.classList.add('disabled', 'restricted');
          btn.style.cursor = 'not-allowed';
          btn.style.opacity = '0.6';
          btn.style.pointerEvents = 'none';
          btn.style.width = '100%';
        });

        this.showRestrictionMessage(productForm, selectedCity);
        this.removeDeliveryTiming();

      } else {
        addToCartButtons.forEach(btn => {
          btn.disabled = false;
          btn.classList.remove('disabled', 'restricted');
          btn.style.cursor = 'pointer';
          btn.style.opacity = '1';
          btn.style.pointerEvents = '';
          btn.style.width = '100%';
        });

        this.removeRestrictionMessage();
        this.showDeliveryTiming(productForm, selectedCity);
      }
    },

    showRestrictionMessage: function(productForm, selectedCity) {
      this.removeRestrictionMessage();

      if (!productForm) return;

      const message = document.createElement('div');
      message.className = 'product-restriction-message';
      message.innerHTML = `
        <div class="restriction-content">
          <h3 class="restriction-heading">Sorry For Inconvenience</h3>
          <p class="restriction-text">This product cannot be delivered to your city due to shipping restrictions for fragile or liquid items.</p>
          <button type="button" onclick="PopupManager.showManual()" class="change-city-btn">Change delivery location</button>
        </div>
      `;

      productForm.insertBefore(message, productForm.firstChild);
    },

    removeRestrictionMessage: function() {
      const existing = document.querySelector('.product-restriction-message');
      if (existing) existing.remove();
    },

    showDeliveryTiming: function(productForm, selectedCity) {
      this.removeDeliveryTiming();

      if (!productForm) return;

      const redesignSection = document.querySelector('.main-product-redesign');
      const configuredQuetta = redesignSection?.dataset.deliveryQuetta;
      const configuredOther = redesignSection?.dataset.deliveryOther;
      const configuredLabel = redesignSection?.dataset.deliveryLabel || 'Delivery:';
      const timing = selectedCity === 'Quetta'
        ? (configuredQuetta || CONFIG.deliveryTiming['Quetta'])
        : (configuredOther || CONFIG.deliveryTiming[selectedCity] || CONFIG.deliveryTiming['default']);

      const timingDisplay = document.createElement('div');
      timingDisplay.className = 'delivery-timing-display';
      const cleanTiming = String(timing || '').replace(/\s+min\b/i, 'min');
      const deliveryCity = selectedCity || 'Quetta';

      timingDisplay.innerHTML = redesignSection ? `
        <div class="delivery-timing-display__badge" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="8.4"></circle>
            <path d="M12 7.5v5l3.2 1.8"></path>
          </svg>
        </div>
        <div class="delivery-timing-display__content">
          <div class="delivery-timing-display__title"><strong>${cleanTiming}</strong> delivery in ${deliveryCity}</div>
          <div class="delivery-timing-display__subtext">Fast delivery based on your selected city</div>
        </div>
      ` : `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="8.5"></circle>
          <path d="M12 7.5v5l3.2 1.8"></path>
        </svg>
        <span>${configuredLabel} <strong>${timing}</strong></span>
      `;

      const redesignButtons = productForm.closest('.main-product-redesign')?.querySelector('.product-form__buttons');
      if (redesignButtons) {
        redesignButtons.insertBefore(timingDisplay, redesignButtons.firstChild);
        return;
      }

      const productType = productForm.querySelector('.product-type, [class*="product-type"], .product__vendor');
      if (productType) {
        productType.parentNode.insertBefore(timingDisplay, productType.nextSibling);
      } else {
        const quantitySelector = productForm.querySelector('.product-form__input, [data-quantity-selector], .quantity');
        if (quantitySelector) {
          const parent = quantitySelector.closest('.product-form__input, .quantity-wrapper') || quantitySelector.parentElement;
          parent.parentNode.insertBefore(timingDisplay, parent);
        }
      }
    },

    removeDeliveryTiming: function() {
      const existing = document.querySelector('.delivery-timing-display');
      if (existing) existing.remove();
    },

    addCollectionBadges: function() {
      const selectedCity = Utils.getSelectedCity();
      if (!selectedCity || selectedCity === 'Quetta') return;

      const productCards = document.querySelectorAll('.product-card, .card-wrapper, .grid-product');

      productCards.forEach(card => {
        if (card.querySelector('.collection-delivery-badge')) return;

        const tags = this.getCardTags(card);
        if (!tags) return;

        const isQuettaOnly = Utils.hasTag(tags, CONFIG.restrictedTag);
        if (!isQuettaOnly) return;

        const badge = document.createElement('div');
        badge.className = 'collection-delivery-badge';
        badge.innerHTML = `
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          Quetta Only
        `;

        const imageWrapper = card.querySelector('.card__media, .product-card__image-wrapper, .grid-product__image-wrapper');
        if (imageWrapper) {
          imageWrapper.style.position = 'relative';
          imageWrapper.appendChild(badge);
        }
      });
    },

    getCardTags: function(card) {
      const tagsAttr = card.getAttribute('data-product-tags');
      if (tagsAttr) return tagsAttr;

      const link = card.querySelector('a[href*="/products/"]');
      if (link && window.theme && window.theme.products) {
        const handle = link.getAttribute('href').split('/products/')[1].split('?')[0];
        const product = window.theme.products[handle];
        if (product) return product.tags;
      }

      return null;
    }
  };

  const CartManager = {
    init: function() {
      this.validateCart();
      
      document.addEventListener('cart:updated', () => {
        this.validateCart();
      });

      document.addEventListener('cityChanged', () => {
        this.validateCart();
      });
    },

    validateCart: async function() {
      const selectedCity = Utils.getSelectedCity();
      if (!selectedCity) return;

      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        const restrictedItems = cart.items.filter(item => {
          const tags = item.product_tags || [];
          const isQuettaOnly = Utils.hasTag(tags, CONFIG.restrictedTag);
          return isQuettaOnly && selectedCity !== 'Quetta';
        });

        if (restrictedItems.length > 0) {
          this.showCartWarning(restrictedItems, selectedCity);
          this.blockCheckout();
        } else {
          this.removeCartWarning();
          this.unblockCheckout();
        }
      } catch (error) {
        console.error('Error validating cart:', error);
      }
    },

    showCartWarning: function(items, selectedCity) {
      this.removeCartWarning();

      const cartForm = document.querySelector('form[action="/cart"]');
      if (!cartForm) return;

      const warning = document.createElement('div');
      warning.className = 'cart-restriction-warning';
      warning.innerHTML = `
        <div class="warning-icon">⚠️</div>
        <div class="warning-content">
          <strong>Delivery Restriction</strong>
          <p>Your cart contains ${items.length} item(s) that can only be delivered to Quetta. You are currently set to deliver to ${selectedCity}.</p>
          <p class="warning-note">Please remove these items or change your location to Quetta to proceed with checkout.</p>
          <button type="button" onclick="PopupManager.showManual()" class="btn-change-city">Change to Quetta</button>
        </div>
      `;

      cartForm.insertBefore(warning, cartForm.firstChild);
    },

    removeCartWarning: function() {
      const existing = document.querySelector('.cart-restriction-warning');
      if (existing) existing.remove();
    },

    blockCheckout: function() {
      const checkoutButtons = document.querySelectorAll(
        'button[name="checkout"], .cart__checkout-button, [href*="/checkout"]'
      );
      
      checkoutButtons.forEach(btn => {
        btn.disabled = true;
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';
        btn.style.pointerEvents = 'none';
        
        if (btn.tagName === 'BUTTON' && !btn.getAttribute('data-original-text')) {
          btn.setAttribute('data-original-text', btn.textContent);
          btn.textContent = 'Remove Restricted Items to Checkout';
        }
      });
    },

    unblockCheckout: function() {
      const checkoutButtons = document.querySelectorAll(
        'button[name="checkout"], .cart__checkout-button, [href*="/checkout"]'
      );
      
      checkoutButtons.forEach(btn => {
        btn.disabled = false;
        btn.style.opacity = '1';
        btn.style.cursor = 'pointer';
        btn.style.pointerEvents = '';
        
        const originalText = btn.getAttribute('data-original-text');
        if (originalText && btn.tagName === 'BUTTON') {
          btn.textContent = originalText;
        }
      });
    }
  };

  const BadgeObserver = {
    observer: null,
    scanScheduled: false,

    clearBadges: function() {
      document.querySelectorAll('.collection-delivery-badge').forEach(badge => badge.remove());
    },

    stop: function() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      this.scanScheduled = false;
    },

    setup: function() {
      this.stop();

      const selectedCity = Utils.getSelectedCity();
      if (!selectedCity || selectedCity === 'Quetta') {
        this.clearBadges();
        return;
      }

      ProductManager.addCollectionBadges();

      const root = document.getElementById('MainContent');
      if (!root) return;

      const cardSelector = '.product-card, .card-wrapper, .grid-product';
      if (!root.querySelector(cardSelector)) {
        this.clearBadges();
        return;
      }

      this.observer = new MutationObserver((mutations) => {
        const hasAddedNodes = mutations.some(mutation => mutation.addedNodes && mutation.addedNodes.length > 0);
        if (!hasAddedNodes || this.scanScheduled) return;

        this.scanScheduled = true;
        const schedule = window.requestAnimationFrame || ((callback) => setTimeout(callback, 16));
        schedule(() => {
          this.scanScheduled = false;
          ProductManager.addCollectionBadges();
        });
      });

      this.observer.observe(root, {
        childList: true,
        subtree: true
      });
    }
  };

  function hasProductCards() {
    return Boolean(document.querySelector('.product-card, .card-wrapper, .grid-product'));
  }

  function hasProductPage() {
    return Boolean(document.querySelector('meta[property="product:tag"], .main-product-redesign'));
  }

  function isCartPage() {
    return window.location.pathname === '/cart' || window.location.pathname.startsWith('/cart?');
  }

  function initCommerce() {
    ProductManager.setupAddToCartTrigger();

    if (hasProductPage()) {
      ProductManager.checkRestrictions();
    }

    if (hasProductCards()) {
      ProductManager.addCollectionBadges();
      BadgeObserver.setup();
    }

    if (isCartPage()) {
      CartManager.init();
    }

    document.addEventListener('cityChanged', () => {
      if (hasProductPage()) {
        ProductManager.checkRestrictions();
      }

      if (hasProductCards()) {
        BadgeObserver.setup();
      } else {
        BadgeObserver.stop();
        BadgeObserver.clearBadges();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCommerce, { once: true });
  } else {
    initCommerce();
  }
})();
